import { useParams } from 'react-router';
import { useApi } from '@axiom/ui';
import { AccountConst } from '@axiom/const';

import { AccountLegacyApi } from '../api/account-legacy-api';
import { UserApi } from '../api/user-api';

export const useUserAccountData = () => {
  const { accountId } = useParams();
  const [{ data: user }] = useApi(UserApi.readUser());

  const foundAccountId = accountId || user.contact?.accounts?.[0]?.id;
  if (!foundAccountId) {
    throw new Error('No accountId provided');
  }

  const [{ data: account }] = useApi(
    AccountLegacyApi.readAccount(foundAccountId, {
      expand: [AccountConst.Expansions.accountTeamUserInfo],
    })
  );

  if (
    account.industryValue?.toLowerCase() === 'na' ||
    account.industryValue?.toLowerCase() === 'n/a'
  ) {
    account.industryValue = null;
  }

  return {
    user,
    account,
  };
};
